export const achievements = [
  {
    img:
      "https://themebeyond.com/demo/gecolive/wp-content/uploads/2020/08/fact_icon01.png",
    number: "245",
    text: "Total Awards",
  },
  {
    img:
      "https://themebeyond.com/demo/gecolive/wp-content/uploads/2020/08/fact_icon03.png",
    number: "2559",
    text: "Honorable Buyres",
  },
  {
    img:
      "https://themebeyond.com/demo/gecolive/wp-content/uploads/2020/08/fact_icon02.png",
    number: "9991",
    text: "Choose us",
  },
  {
    img:
      "https://themebeyond.com/demo/gecolive/wp-content/uploads/2020/08/fact_icon04.png",
    number: "59",
    text: "Amazing Feature",
  },
];
